import { Grid } from "@mui/material";
import LoaderBox from "@entrilia/shared/components/LoaderBox";
import type { FundStage, FundWithFieldValues } from "../../../../api/types/fundStructureTypes";
import FundInfoCard from "./FundInfoCard";

interface Props {
  funds: FundWithFieldValues[];
  onFundClick: (id: string) => void;
  isLoading: boolean;
}

const FundsCardList = ({ funds, onFundClick, isLoading }: Props) => (
  <LoaderBox loading={isLoading}>
    <Grid container spacing={2.5}>
      {funds.map((fund) => (
        <Grid key={fund.id}>
          <FundInfoCard
            name={fund.name}
            investorsCount={fund.investorsCount ?? 0}
            stage={fund.fieldValues["Stage"] as FundStage}
            onClick={() => onFundClick(fund.id)}
          />
        </Grid>
      ))}
    </Grid>
  </LoaderBox>
);

export default FundsCardList;
